import { useLazyLoadQuery } from "react-relay"
import { graphql } from "relay-runtime"
import { useNewsQuery as useNewsQueryType } from "@/modules/admin/news/services/__generated__/useNewsQuery.graphql"

export const NewsConnectionKey = "NewsConnection_news"

export const newsQuery = graphql`
  query useNewsQuery {
    news(first: null) @connection(key: "NewsConnection_news") {
      edges {
        node {
          id
          isShowing
          ...NewsFragment
        }
      }
    }
  }
`

export default function useNewsQuery() {
  const data = useLazyLoadQuery<useNewsQueryType>(
    newsQuery,
    {},
    {
      fetchPolicy: "store-and-network",
    },
  )

  return [data]
}
